// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Cn = require("re-classnames/src/Cn.bs.js");
var Css = require("bs-css-emotion/src/Css.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("@rescript/std/lib/js/caml_obj.js");
var Js_array = require("@rescript/std/lib/js/js_array.js");
var Util_Css = require("../../util/Util_Css.bs.js");
var Belt_List = require("@rescript/std/lib/js/belt_List.js");
var Belt_Array = require("@rescript/std/lib/js/belt_Array.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Common = require("../../type/Type_Common.bs.js");
var Particle_Css = require("../particle/Particle_Css.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Border_Css = require("../particle/Particle_Border_Css.bs.js");
var Particle_Device_Css = require("../particle/Particle_Device_Css.bs.js");
var Particle_Screen_Css = require("../particle/Particle_Screen_Css.bs.js");
var Particle_Spacer_Css = require("../particle/Particle_Spacer_Css.bs.js");
var Particle_Accessibility = require("../particle/Particle_Accessibility.bs.js");
var Particle_Animation_Css = require("../particle/Particle_Animation_Css.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Background_Css = require("../particle/Particle_Background_Css.bs.js");

function targetToString(x) {
  if (x === "Self") {
    return "_self";
  } else {
    return "_blank";
  }
}

function downloadToString(x) {
  if (typeof x === "object") {
    return x.VAL;
  } else {
    return "";
  }
}

function getDisplayRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(Particle_Css.font_display, param);
              }), param);
}

function getDirectionRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.flexDirection, param);
              }), param);
}

function getWidthRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.width, param);
              }), param);
}

function getMaxWidthRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.maxWidth, param);
              }), param);
}

function getMaxHeightRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.maxHeight, param);
              }), param);
}

function getMinHeightRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.minHeight, param);
              }), param);
}

function getAlignItemsRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.alignItems, param);
              }), param);
}

function getAlignSelfRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.alignSelf, param);
              }), param);
}

function getDisplayOrderRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.order, param);
              }), param);
}

function getHeightRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.height, param);
              }), param);
}

function getJustifyContentRules(param) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(CssJs.justifyContent, param);
              }), param);
}

function getAutoSizeRule(autoSize) {
  switch (autoSize) {
    case /* AllPlaceAvailable */0 :
        return CssJs.flex3(1, 1, Css.px(0));
    case /* AllPlaceNeeded */1 :
        return CssJs.flex3(1, 0, "auto");
    case /* MaxContent */2 :
        return CssJs.flex("initial");
    case /* NoResizing */3 :
        return CssJs.flex3(0, 0, "auto");
    
  }
}

function getAutoSizeRules(autoSize) {
  return Particle_Screen_Css.toRules(undefined, undefined, (function (param) {
                return Util_Css.toRules(getAutoSizeRule, param);
              }), autoSize);
}

var defaultDisplay = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.flexBox);

var defaultDisplayView = Particle_Screen_Ds.view(defaultDisplay);

function getClassByKind(display, _kind) {
  while(true) {
    var kind = _kind;
    var match = Particle_Screen_Ds.view(display);
    if (typeof kind === "number") {
      if (kind === /* List */5) {
        return [
                CssJs.listStyleType("none"),
                CssJs.margin(CssJs.px(0))
              ];
      } else {
        return [];
      }
    }
    if (kind.TAG !== /* WithPseudoElement */14) {
      return [];
    }
    var kind$1 = kind._0;
    if (typeof kind$1 === "number") {
      _kind = kind$1;
      continue ;
    }
    if (kind$1.TAG === /* Text */13) {
      if (kind$1._0 === "span") {
        if (Caml_obj.equal(defaultDisplayView, match)) {
          return [CssJs.display(CssJs.inlineFlex)];
        }
        _kind = kind$1;
        continue ;
      }
      _kind = kind$1;
      continue ;
    }
    _kind = kind$1;
    continue ;
  };
}

function getTagAndProps(id, ref, className, accessibility, onFocus, onBlur, onMouseEnter, onMouseLeave, dataAnchor, identifier, kind) {
  var makePropsWithoutClassName = function (className) {
    return function (param, param$1, param$2, param$3, param$4, param$5, param$6, param$7, param$8, param$9, param$10, param$11, param$12, param$13, param$14) {
      return function (param$15, param$16, param$17, param$18, param$19, param$20, param$21, param$22) {
        var match = Belt_Option.mapWithDefault(param$21, Particle_Accessibility.defaultView, Particle_Accessibility.view);
        var rel = Belt_Option.map(param$15, Type_Common.Rel.toString);
        return {
                alt: param,
                "aria-controls": match.ariaControls,
                "aria-current": match.ariaCurrent,
                "aria-describedby": match.ariaDescribedby,
                "aria-disabled": match.ariaDisabled,
                "aria-expanded": match.ariaExpanded,
                "aria-haspopup": match.ariaHasPopup,
                "aria-hidden": match.ariaHidden,
                "aria-label": match.ariaLabel,
                "aria-labelledby": match.ariaLabelledby,
                "aria-live": match.ariaLive,
                "aria-modal": match.ariaModal,
                "aria-roledescription": match.ariaRoledescription,
                autoComplete: param$1,
                box: param$2,
                className: className,
                dangerouslySetInnerHTML: Belt_Option.map(param$3, (function (content) {
                        return {
                                __html: content
                              };
                      })),
                "data-anchor": param$5,
                "data-testid": identifier,
                defaultValue: param$6,
                disabled: param$4,
                download: param$7,
                href: param$8,
                htmlFor: param$9,
                id: id,
                lang: match.lang,
                loading: param$10,
                name: param$11,
                onBlur: onBlur,
                onChange: param$12,
                onClick: param$13,
                onFocus: onFocus,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onSubmit: param$14,
                ref: ref,
                rel: rel,
                role: match.role,
                src: param$16,
                tabIndex: match.tabIndex,
                target: param$17,
                title: param$18,
                type: param$19,
                value: param$20
              };
      };
    };
  };
  var makeProps = makePropsWithoutClassName(className);
  var _x = kind;
  while(true) {
    var x = _x;
    if (x !== undefined) {
      if (typeof x === "number") {
        switch (x) {
          case /* Blockquote */0 :
              return [
                      "blockquote",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Figure */1 :
              return [
                      "figure",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Footer */2 :
              return [
                      "footer",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Header */3 :
              var accessibility$1 = Belt_Option.mapWithDefault(accessibility, Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Banner", undefined, undefined), (function (__x) {
                      return Particle_Accessibility.set(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Banner", undefined, __x);
                    }));
              return [
                      "header",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility$1,
                            undefined
                          ])
                    ];
          case /* ItemList */4 :
              return [
                      "li",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* List */5 :
              return [
                      "ul",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Main */6 :
              return [
                      "main",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Main", undefined, undefined),
                            undefined
                          ])
                    ];
          case /* Section */7 :
              return [
                      "section",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Span */8 :
              return [
                      "span",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          
        }
      } else {
        switch (x.TAG | 0) {
          case /* EbuBox */0 :
              var match = x._0;
              return [
                      "div",
                      Curry._8(makePropsWithoutClassName(match.className)(undefined, undefined, match.ebuBox, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined), undefined, undefined, undefined, undefined, undefined, undefined, accessibility, undefined)
                    ];
          case /* Button */1 :
              return [
                      "button",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._1,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._2,
                            x._0,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* ButtonDisabled */2 :
              return [
                      "button",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            true,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._0,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* DangerouslySetInnerHTML */3 :
              return [
                      "div",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            x._0,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Dialog */4 :
              return [
                      "div",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            Particle_Accessibility.makeDialog(x._0),
                            undefined
                          ])
                    ];
          case /* DownloadLink */5 :
              var download = downloadToString(x._1);
              return [
                      "a",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            download,
                            x._0,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            Caml_option.some(Type_Common.Rel.make("noreferrer")),
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined
                          ])
                    ];
          case /* Form */6 :
              return [
                      "form",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._0,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Image */7 :
              var alt = x._1;
              return [
                      "img",
                      Curry.app(makeProps, [
                            alt,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            "lazy",
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._0,
                            undefined,
                            alt,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Label */8 :
              return [
                      "label",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._0,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Link */9 :
              var rel = x._4;
              var onClick = x._3;
              var title = x._2;
              var target = x._1;
              var href = x._0;
              if (target === "Self") {
                return [
                        "a",
                        Curry.app(makeProps, [
                              undefined,
                              undefined,
                              undefined,
                              undefined,
                              undefined,
                              dataAnchor,
                              undefined,
                              undefined,
                              href,
                              undefined,
                              undefined,
                              undefined,
                              undefined,
                              onClick,
                              undefined,
                              rel,
                              undefined,
                              targetToString(target),
                              title,
                              undefined,
                              undefined,
                              accessibility,
                              undefined
                            ])
                      ];
              }
              if (target === "Blank") {
                var rel$1 = Belt_Option.getWithDefault(Belt_Option.map(rel, (function (rel) {
                            return Type_Common.Rel.add(rel, "noopener");
                          })), Type_Common.Rel.make("noopener"));
                return [
                        "a",
                        Curry.app(makeProps, [
                              undefined,
                              undefined,
                              undefined,
                              undefined,
                              undefined,
                              dataAnchor,
                              undefined,
                              undefined,
                              href,
                              undefined,
                              undefined,
                              undefined,
                              undefined,
                              onClick,
                              undefined,
                              Caml_option.some(rel$1),
                              undefined,
                              targetToString(target),
                              title,
                              undefined,
                              undefined,
                              accessibility,
                              undefined
                            ])
                      ];
              }
              break;
          case /* Nav */10 :
              var ariaLabel = x._0;
              var accessibility$2 = Belt_Option.mapWithDefault(accessibility, Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, ariaLabel, undefined, undefined, undefined, undefined, "Navigation", undefined, undefined), (function(ariaLabel){
                  return function (__x) {
                    return Particle_Accessibility.set(undefined, undefined, undefined, undefined, undefined, undefined, undefined, ariaLabel, undefined, undefined, undefined, undefined, "Navigation", undefined, __x);
                  }
                  }(ariaLabel)));
              return [
                      "nav",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility$2,
                            undefined
                          ])
                    ];
          case /* Option */11 :
              return [
                      "option",
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._0,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Select */12 :
              return [
                      "select",
                      Curry.app(makeProps, [
                            undefined,
                            x._4,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._0,
                            x._2,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            x._3,
                            undefined,
                            x._1,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* Text */13 :
              return [
                      x._0,
                      Curry.app(makeProps, [
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            undefined,
                            accessibility,
                            undefined
                          ])
                    ];
          case /* WithPseudoElement */14 :
              _x = x._0;
              continue ;
          
        }
      }
    }
    return [
            "div",
            Curry.app(makeProps, [
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  undefined,
                  accessibility,
                  undefined
                ])
          ];
  };
}

function getBaseRules(alignItems, alignSelf, animation, area, autoSize, background, border, deviceRules, direction, displayOpt, displayOrder, height, justifyContent, kind, maxHeight, maxWidth, minHeight, spacer, width, wrap, param) {
  var display = displayOpt !== undefined ? Caml_option.valFromOption(displayOpt) : defaultDisplay;
  var boxRules = [CssJs.position(CssJs.relative)];
  var widthRules = Belt_Option.map(width, getWidthRules);
  var maxWidthRules = Belt_Option.map(maxWidth, getMaxWidthRules);
  var heightRules = Belt_Option.map(height, getHeightRules);
  var maxHeightRules = Belt_Option.map(maxHeight, getMaxHeightRules);
  var minHeightRules = Belt_Option.map(minHeight, getMinHeightRules);
  var alignItemsRules = Belt_Option.map(alignItems, getAlignItemsRules);
  var alignSelfRules = Belt_Option.map(alignSelf, getAlignSelfRules);
  var justifyContentRules = Belt_Option.map(justifyContent, getJustifyContentRules);
  var directionRules = Belt_Option.map(direction, getDirectionRules);
  var displayRules = getDisplayRules(display);
  var deviceRules$1 = Belt_Option.map(deviceRules, Particle_Device_Css.toRules);
  var kindRules = Belt_Option.map(kind, (function (param) {
          return getClassByKind(display, param);
        }));
  var spacerRules = Belt_Option.map(spacer, Curry._3(Particle_Screen_Css.toRules, undefined, undefined, Particle_Spacer_Css.toCss));
  var displayOrderRules = Belt_Option.map(displayOrder, getDisplayOrderRules);
  var areaRules = Belt_Option.map(area, (function (area) {
          return [CssJs.gridArea({
                        NAME: "ident",
                        VAL: area
                      })];
        }));
  var borderRules = Belt_Option.map(border, Curry._3(Particle_Screen_Css.toRules, undefined, undefined, Particle_Border_Css.toCss));
  var animationRules = Belt_Option.map(animation, Particle_Animation_Css.toCss);
  var autoSizeRules = Belt_Option.map(autoSize, getAutoSizeRules);
  var wrapRules = wrap !== undefined ? (
      wrap ? [CssJs.flexWrap("nowrap")] : [CssJs.flexWrap("wrap")]
    ) : [CssJs.flexWrap("nowrap")];
  var backgroundRules = Particle_Background_Css.toCss(Belt_Option.getWithDefault(background, Particle_Background_Ds.transparent));
  return Belt_Array.reduce([
              boxRules,
              widthRules,
              maxWidthRules,
              heightRules,
              maxHeightRules,
              minHeightRules,
              alignItemsRules,
              alignSelfRules,
              justifyContentRules,
              directionRules,
              wrapRules,
              autoSizeRules,
              displayOrderRules,
              displayRules,
              deviceRules$1,
              borderRules,
              animationRules,
              spacerRules,
              backgroundRules,
              areaRules,
              kindRules
            ], [], (function (acc, rules) {
                if (rules !== undefined && rules.length !== 0) {
                  Js_array.push(rules, acc);
                  return acc;
                } else {
                  return acc;
                }
              }));
}

function getGapRules(display, gap) {
  var zipWithIteratee = function (display, gap) {
    if (display === "grid") {
      return Util_Css.toRules(CssJs.gridGap, Particle_Css.spacerSizeInside(gap));
    } else {
      return Util_Css.gapPolyfill(Particle_Css.spacerSizeInsideValue(gap));
    }
  };
  return Belt_Option.getWithDefault(Belt_Option.map(gap, (function (gap) {
                    return Particle_Screen_Css.toRules(undefined, undefined, (function (array) {
                                  return array;
                                }), Particle_Screen_Ds.zipWith(zipWithIteratee, display, gap));
                  })), []);
}

function getInnerSpaceRules(direction, innerSpace) {
  var zipWithIteratee = function (direction, innerSpace) {
    if (direction === "unset" || direction === "rowReverse" || direction === "row" || direction === "inherit_" || direction === "initial") {
      return Particle_Spacer_Ds.Outside.make("None", "Zero", "None", innerSpace, undefined);
    } else {
      return Particle_Spacer_Ds.Outside.make("None", innerSpace, "None", "Zero", undefined);
    }
  };
  var innerSpaceScreen = innerSpace !== undefined && direction !== undefined ? Particle_Screen_Ds.zipWith(zipWithIteratee, Caml_option.valFromOption(direction), Caml_option.valFromOption(innerSpace)) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeNone(undefined));
  var particleScreenToCssJsRulesTransformer = function (spacer) {
    var rules = Particle_Spacer_Css.toCss(spacer);
    return [CssJs.children([CssJs.selector(":not(:last-child)", rules)])];
  };
  return Particle_Screen_Css.toRules(undefined, undefined, particleScreenToCssJsRulesTransformer, innerSpaceScreen);
}

function Atom_Box(Props) {
  var accessibility = Props.accessibility;
  var alignItems = Props.alignItems;
  var alignSelf = Props.alignSelf;
  var animation = Props.animation;
  var area = Props.area;
  var autoSize = Props.autoSize;
  var background = Props.background;
  var border = Props.border;
  var childRules = Props.childRules;
  var childrenOpt = Props.children;
  var dataAnchor = Props.dataAnchor;
  var deviceRules = Props.deviceRules;
  var direction = Props.direction;
  var displayOpt = Props.display;
  var displayOrder = Props.displayOrder;
  var gap = Props.gap;
  var height = Props.height;
  var id = Props.id;
  var identifier = Props.identifier;
  var justifyContent = Props.justifyContent;
  var kind = Props.kind;
  var maxHeight = Props.maxHeight;
  var maxWidth = Props.maxWidth;
  var mediaQueryKind = Props.mediaQueryKind;
  var minHeight = Props.minHeight;
  var onBlur = Props.onBlur;
  var onFocus = Props.onFocus;
  var onMouseEnter = Props.onMouseEnter;
  var onMouseLeave = Props.onMouseLeave;
  var rules = Props.rules;
  var spacer = Props.spacer;
  var width = Props.width;
  var wrap = Props.wrap;
  var innerSpace = Props.innerSpace;
  var ref_ = Props.ref_;
  var cbRef = Props.cbRef;
  var children = childrenOpt !== undefined ? Caml_option.valFromOption(childrenOpt) : null;
  var display = displayOpt !== undefined ? Caml_option.valFromOption(displayOpt) : defaultDisplay;
  var baseRules = getBaseRules(alignItems, alignSelf, undefined, area, autoSize, background, border, deviceRules, direction, Caml_option.some(display), displayOrder, height, justifyContent, kind, maxHeight, maxWidth, minHeight, spacer, width, wrap, undefined);
  var innerSpaceRules = getInnerSpaceRules(direction, innerSpace);
  var gapRules = getGapRules(display, gap);
  var baseRulesWithOthersRules = Belt_Array.concat(Belt_Array.concat(baseRules, [innerSpaceRules]), [gapRules]);
  var childClass = Cn.take(Util_Css.makeChildClass(childRules));
  var baseClass = Cn.fromList(Belt_List.fromArray(Belt_Array.mapU(baseRulesWithOthersRules, CssJs.style)));
  var animationClass = Belt_Option.getWithDefault(Belt_Option.map(Belt_Option.map(animation, Particle_Animation_Css.toCss), (function (__x) {
              return CssJs.style(__x);
            })), "");
  var className = Belt_Option.map(Belt_Option.map(Belt_Option.map(rules, (function (param) {
                  return Particle_Screen_Css.toRules(undefined, mediaQueryKind, (function (l) {
                                return l;
                              }), param);
                })), (function (__x) {
              return Belt_Array.map(__x, (function (rule) {
                            var __x = [rule];
                            return CssJs.style(__x);
                          }));
            })), (function (__x) {
          return CssJs.merge(__x);
        }));
  var match = Belt_Option.map(ref_, (function (prim) {
          return prim;
        }));
  var match$1 = Belt_Option.map(cbRef, (function (prim) {
          return prim;
        }));
  var ensuredRef;
  if (match !== undefined) {
    var ref = Caml_option.valFromOption(match);
    if (match$1 !== undefined) {
      console.log("Warning: both ref_ and cbRef are provided, cbRef will be ignored");
      ensuredRef = Caml_option.some(ref);
    } else {
      ensuredRef = Caml_option.some(ref);
    }
  } else {
    ensuredRef = match$1 !== undefined ? Caml_option.some(Caml_option.valFromOption(match$1)) : undefined;
  }
  var match$2 = getTagAndProps(id, ensuredRef, CssJs.merge([
            baseClass,
            childClass,
            animationClass,
            Cn.take(className)
          ]), accessibility, onFocus, onBlur, onMouseEnter, onMouseLeave, dataAnchor, identifier, kind);
  return React.createElement(match$2[0], match$2[1], children);
}

Atom_Box.displayName = "Box";

var make = Atom_Box;

exports.getAutoSizeRule = getAutoSizeRule;
exports.defaultDisplay = defaultDisplay;
exports.getClassByKind = getClassByKind;
exports.getTagAndProps = getTagAndProps;
exports.getBaseRules = getBaseRules;
exports.make = make;
/* defaultDisplay Not a pure module */
